import type { SxProps, Theme } from "@mui/material/styles";
export const groups: SxProps<Theme> = { display: "flex", flexDirection: "column", gap: { xs: 1.25, md: 1.75 } };
export const shield: SxProps<Theme> = { bgcolor: "background.default", borderRadius: 1.75, p: { xs: 1.75, md: 2 }, display: "flex", alignItems: "center", gap: 1.25 };
export const text: SxProps<Theme> = { fontSize: { xs: ".6875rem", md: ".75rem" }, color: "text.secondary", lineHeight: 1.7 };
